import { IApiDataType } from '../types'
import {
  useBbbCompanyFilter,
  useBbbCorporateOpportunitiesFilter,
  useBbbExecutiveSummaryFilter,
  useBbbStoreOpportunitiesFilter,
} from './useBbbCompanyFilter'
import {
  useBbbCorporateFilter,
  useBbbPnlCorporateFilter,
} from './useBbbCorporateFilter'
import {
  useBbbCorporateWithoutBreakdownFilter,
  useBbbPnlCorporateWithoutBreakdownFilter,
} from './useBbbCorporateWithoutBreakdownFilter'
import useCompanyFilter from './useCompanyFilter'
import useCorporateFilter from './useCorporateFilter'
import useCorporateWithoutBreakdownAndLocationFilter from './useCorporateWithoutBreakdownAndLocationFilter'
import useCorporateWithoutBreakdownFilter from './useCorporateWithoutBreakdownFilter'
import useDrgGroupFilter from './useDrgGroupFilter'
import useFwWingstopCorporateFilter from './useFwWingstopCorporateFilter'
import useFwWingstopCorporateWithoutBreakdownFilter from './useFwWingstopCorporateWithoutBreakdownFilter'
import useFwWingstopWeeklyLaborTrackerFilter from './useFwWingstopWeeklyLaborTrackerFilter'
import useJscBkGroupFilter from './useJscBkGroupFilter'
import useLegalEntityFilter from './useLegalEntityFilter'
import useLegalEntityWithoutLocationsFilter from './useLegalEntityWithoutLocationsFilter'
import useLfrBrandsGroupFilter from './useLfrBrandsGroupFilter'
import useLfrGfpAllGroupFilter from './useLfrGfpAllGroupFilter'
import useLfrGroupFilter from './useLfrGroupFilter'
import {
  useBbbCompanyLocationFilter,
  useFwWingstopPrepCalculatorLocationFilter,
  useLocationFilter,
} from './useLocationFilter'

export type IApiKeyType = keyof typeof api

const api = {
  lfrGroupFilter: useLfrGroupFilter,
  lfrBrandsGroupFilter: useLfrBrandsGroupFilter,
  corporateFilter: useCorporateFilter,
  locationFilter: useLocationFilter,
  jscBkGroupFilter: useJscBkGroupFilter,
  drgGroupFilter: useDrgGroupFilter,
  lfrGfpAllGroupFilter: useLfrGfpAllGroupFilter,
  corporateWithoutBreakdownFilter: useCorporateWithoutBreakdownFilter,
  corporateWithoutBreakdownAndLocationFilter:
    useCorporateWithoutBreakdownAndLocationFilter,
  bbbCorporateFilter: useBbbCorporateFilter,
  bbbCorporateWithoutBreakdownFilter: useBbbCorporateWithoutBreakdownFilter,
  bbbPnlCorporateFilter: useBbbPnlCorporateFilter,
  bbbPnlCorporateWithoutBreakdownFilter:
    useBbbPnlCorporateWithoutBreakdownFilter,
  bbbCompanyFilter: useBbbCompanyFilter,
  bbbExecutiveSummaryFilter: useBbbExecutiveSummaryFilter,
  bbbCorporateOpportunitiesFilter: useBbbCorporateOpportunitiesFilter,
  bbbStoreOpportunitiesFilter: useBbbStoreOpportunitiesFilter,
  bbbCompanyLocationFilter: useBbbCompanyLocationFilter,
  fwWingstopCorporateFilter: useFwWingstopCorporateFilter,
  fwWingstopWeeklyLaborTrackerFilter: useFwWingstopWeeklyLaborTrackerFilter,
  fwWingstopCorporateWithoutBreakdownFilter:
    useFwWingstopCorporateWithoutBreakdownFilter,
  fwWingstopPrepCalculatorLocationFilter:
    useFwWingstopPrepCalculatorLocationFilter,
  companyFilter: useCompanyFilter,
  legalEntityFilter: useLegalEntityFilter,
  legalEntityWithoutLocationsFilter: useLegalEntityWithoutLocationsFilter,
}

const useApi = (
  apiName: IApiKeyType,
): {
  data: IApiDataType
  loading: boolean
} => api[apiName]()

export default useApi
